import { FC } from 'react';

const iconCactus = require('./icon_cactus.svg');

export const IconCactus: FC = () => {
  return <img alt="icon_cactus" height={82} src={iconCactus} width={59} />;
};

IconCactus.displayName = 'IconCactus';
